<div *ngIf="success || error" tamsyMargin marginY="10px">
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>

<div fxLayout="row" fxLayoutGap="30px" appMargin marginT="10">
  <div fxFlex="20%" fxLayout="column" fxLayoutGap="10px">
    <div
      class="side-panel text-center"
      appPadding="5"
      fxLayout="column"
      fxLayoutGap="10px"
      fxLayoutAlign="space-between center"
    >
      <div fxFlex>
        <img [src]="image" class="ui circular image" />
      </div>
      <div fxFlex>
        <button
          class="ui primary button"
          (click)="changeImage()"
          [ngClass]="{ loading: pending }"
        >
          Change
        </button>
      </div>
    </div>
  </div>

  <div fxFlex="grow">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <h3 appMargin marginB="0">Profile Details</h3>
      <button (click)="edit()" class="ui tiny icon button">
        <i class="pencil icon"></i>
      </button>
    </div>
    <hr />

    <div class="ui vertical basic segment">
      <div fxLayout="row">
        <div fxFlex="30%"><strong>First Name</strong></div>
        <div fxFlex="grow">{{ user?.firstName }}</div>
      </div>
      <div class="ui divider"></div>

      <div fxLayout="row">
        <div fxFlex="30%"><strong>Last Name</strong></div>
        <div fxFlex="grow">{{ user?.lastName }}</div>
      </div>
      <div class="ui divider"></div>

      <div fxLayout="row">
        <div fxFlex="30%"><strong>Middle Name</strong></div>
        <div fxFlex="grow">{{ user?.middleName }}</div>
      </div>
      <div class="ui divider"></div>

      <div fxLayout="row">
        <div fxFlex="30%"><strong>Role</strong></div>
        <div fxFlex="grow">{{ user?.roleId?.roleName }}</div>
      </div>
      <div class="ui divider"></div>

      <div fxLayout="row">
        <div fxFlex="30%"><strong>User Type</strong></div>
        <div fxFlex="grow">{{ user?.userType }}</div>
      </div>
      <div class="ui divider"></div>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center">
      <h3 appMargin marginB="0">Username and Email</h3>
    </div>
    <hr />

    <div class="ui vertical basic segment">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxFlex="30%"><strong>Username</strong></div>
        <div fxFlex="grow">{{ userName }}</div>
        <div fxFlex="10%" class="text-right">
          <button (click)="username(true)" class="ui tiny icon button">
            <i class="pencil icon"></i>
          </button>
        </div>
      </div>
      <div class="ui divider"></div>

      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxFlex="30%"><strong>Email</strong></div>
        <div fxFlex="grow">{{ email }}</div>
        <div fxFlex="10%" class="text-right">
          <button (click)="username(false)" class="ui tiny icon button">
            <i class="pencil icon"></i>
          </button>
        </div>
      </div>
      <div class="ui divider"></div>
    </div>
  </div>
</div>
